import React, { useEffect, useState } from 'react'
import { Row, Col, Form, DatePicker } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import { DATE_PICKER_FORMAT } from '../../constants/date'
import { LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'

export default function ManageConsiderationRoundForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  editObj,
  minStartDate,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(
    editObj?.startDate ? moment(editObj.startDate, DATE_PICKER_FORMAT).toDate() : ''
  )
  const [endDate, setEndDate] = useState(
    editObj?.endDate ? moment(editObj.endDate, DATE_PICKER_FORMAT).toDate() : ''
  )

  const enableStartDate = minStartDate ? moment(minStartDate, DATE_PICKER_FORMAT).toDate() : ''

  return (
    <>
      {formSchema && (
        <Form fluid>
          <div>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={formSchema.roundName}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  value={editObj?.roundName}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Row>
                  <ErrorMessage error={errors.startDate} />
                  {requiredFiled(formSchema.startDate.validators, formSchema.startDate.label)}

                  <Controller
                    name={formSchema.startDate.name}
                    control={control}
                    defaultValue={startDate}
                    rules={isValidators(formSchema.startDate.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format={DATE_PICKER_FORMAT}
                          locale={LOCAL_DAY_TH}
                          block
                          placement="auto"
                          value={startDate}
                          style={{ width: '100%' }}
                          placeholder={formSchema.startDate.label}
                          onChange={(value) => {
                            props.onChange(value)
                            setStartDate(value)
                          }}
                          disabledDate={(date) =>
                            enableStartDate &&
                            moment(moment(enableStartDate).add(1, 'days')).isAfter(date, new Date())
                          }
                          // disabled={disabled}
                        />
                      )
                    }}
                  />
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Row style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors.endDate} />
                  {requiredFiled(formSchema.endDate.validators, formSchema.endDate.label)}
                  <Controller
                    name={formSchema.endDate.name}
                    control={control}
                    defaultValue={endDate}
                    rules={isValidators(formSchema.endDate.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format={DATE_PICKER_FORMAT}
                          locale={LOCAL_DAY_TH}
                          block
                          placement="auto"
                          value={endDate}
                          style={{ width: '100%' }}
                          placeholder={formSchema.endDate.label}
                          onChange={(value) => {
                            props.onChange(value)
                            setEndDate(value)
                          }}
                          disabledDate={(date) =>
                            startDate &&
                            moment(moment(startDate).add(1, 'days')).isAfter(date, new Date())
                          }
                          // disabled={disabled}
                        />
                      )
                    }}
                  />
                </Row>
              </Col>

              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={formSchema.description}
                  rows={4}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  value={editObj?.description}
                />
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </>
  )
}
